import { Mutation, MutationTree } from "vuex";
import { PlayerMutation, PlayerState } from "@/components/player/types";

export const mutations: MutationTree<PlayerState> &
  Record<PlayerMutation, Mutation<PlayerState>> = {
  [PlayerMutation.SetPause](state, pause: boolean) {
    state.pause = pause;
  }
};
